import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ModulIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.25 2.162V4.64c0 .336 0 .504.068.632a.62.62 0 0 0 .273.263c.134.065.309.065.659.065h2.582M13 6.793v4.327c0 1.008 0 1.512-.204 1.897-.18.339-.467.614-.82.787C11.576 14 11.05 14 10 14H6c-1.05 0-1.575 0-1.976-.196a1.84 1.84 0 0 1-.82-.787C3 12.632 3 12.128 3 11.12V4.88c0-1.008 0-1.512.204-1.897a1.84 1.84 0 0 1 .82-.787C4.424 2 4.95 2 6 2h2.007c.459 0 .688 0 .904.05q.288.067.542.215c.19.112.351.267.676.579l1.992 1.912c.325.312.487.467.603.65q.154.242.224.52c.052.207.052.427.052.867" /></svg>
  );
}

export default ModulIcon;
